import { Stack } from '@mui/material';
import DashboardWidgetCard from '../../Dashboard/DashboardWidgetCard';
import StatRow from './StatRow';
import { formatNumber } from './dashboardFormat';

// Widget 4 — automation health of the flow's enrollments; failed GetResponse
// syncs are highlighted in red.
export default function AutomationWidget({ automation, loading, error, onRetry }) {
  const retrying = Number(automation?.getresponseRetrying) || 0;
  const failed = Number(automation?.getresponseFailed) || 0;

  return (
    <DashboardWidgetCard
      title='Automation & GetResponse'
      icon='AccountTree'
      accent='info'
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Stack spacing={1} sx={{ flexGrow: 1 }} justifyContent='center'>
        <StatRow label='Aktive Kontakte' value={formatNumber(automation?.active)} />
        <StatRow label='Wartend (nächster Schritt)' value={formatNumber(automation?.waiting)} />
        <StatRow label='Abgeschlossen' value={formatNumber(automation?.completed)} />
        <StatRow label='Ausgeschieden' value={formatNumber(automation?.exited)} />
        <StatRow
          label='GetResponse-Sync in Wiederholung'
          value={formatNumber(retrying)}
          valueColor={retrying > 0 ? 'warning.main' : undefined}
        />
        <StatRow
          label='GetResponse-Sync fehlgeschlagen'
          value={formatNumber(failed)}
          valueColor={failed > 0 ? 'error.main' : undefined}
        />
      </Stack>
    </DashboardWidgetCard>
  );
}
